import React, { useState } from "react";
import * as FaIcons from "react-icons/fa";
import { CURRENCY_OPTIONS } from "../Applications/ApplicationCostSection";

const ApplicationFeeRuleModal = ({
  show,
  onClose,
  onSave,
  loading,
  formData,
  setFormData,
  isEditing = false,
}) => {
  const countries = ["Australia", "Pakistan", "United Arab Emirates"];
  const applicationTypes = ["education", "migration"];
  const currencies = CURRENCY_OPTIONS;
  const [errors, setErrors] = useState({});

  if (!show) return null;

  const handleSubmitForm = () => {
    const { name, country, application_type, fee_per_application, currency } =
      formData;
    const newErrors = {};

    if (!name?.trim()) newErrors.name = "Rule Name is required.";
    if (!country) newErrors.country = "Please select a country.";
    if (!application_type)
      newErrors.application_type = "Please select an Application Type.";
    if (
      !fee_per_application ||
      isNaN(fee_per_application) ||
      fee_per_application <= 0
    )
      newErrors.fee_per_application =
        "Fee must be a positive number greater than 0.";
    if (!currency) newErrors.currency = "Please select a Currency.";

    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      onSave();
    }
  };

  return (
    <>
      {/* Backdrop */}
      <div
        className="modal-backdrop fade show"
        style={{
          display: "block",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1040,
        }}
        onClick={() => {
          setErrors({});
          onClose();
        }}
      />

      {/* Modal */}
      <div
        className="modal fade show d-block"
        tabIndex="-1"
        role="dialog"
        style={{ zIndex: 1050 }}
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          style={{ maxWidth: "600px" }}
        >
          <div className="modal-content border-0 rounded-3">
            {/* Header */}
            <div className="modal-header border-bottom p-3">
              <h5 className="modal-title fw-semibold text-white">
                {isEditing ? "Edit Fee Rule" : "Create Fee Rule"}
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                onClick={() => {
                  setErrors({});
                  onClose();
                }}
                disabled={loading}
                aria-label="Close"
              />
            </div>

            {/* Body */}
            <div className="modal-body p-4">
              <div className="row g-3">
                {/* Rule Name */}
                <div className="col-12">
                  <label className="form-label fw-medium">
                    Rule Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="e.g. Pakistan-Education-2000"
                    value={formData.name}
                    onChange={(e) =>
                      setFormData((prev) => ({ ...prev, name: e.target.value }))
                    }
                  />
                  {errors.name && (
                    <small className="text-danger mt-1 d-block">
                      {errors.name}
                    </small>
                  )}
                  <small className="text-muted mt-1 d-block">
                    Format: Country-Type-Fee (e.g., Pakistan-Education-2000)
                  </small>
                </div>

                {/* Country */}
                <div className="col-md-6">
                  <label className="form-label fw-medium">
                    Country <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    value={formData.country}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        country: e.target.value,
                      }))
                    }
                  >
                    <option value="" disabled>
                      Select country
                    </option>
                    {countries.map((country) => (
                      <option key={country} value={country}>
                        {country}
                      </option>
                    ))}
                  </select>
                  {errors.country && (
                    <small className="text-danger mt-1 d-block">
                      {errors.country}
                    </small>
                  )}
                </div>

                {/* Application Type */}
                <div className="col-md-6">
                  <label className="form-label fw-medium">
                    Application Type <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    value={formData.application_type}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        application_type: e.target.value,
                      }))
                    }
                  >
                    <option value="" disabled>
                      Select type
                    </option>
                    {applicationTypes.map((type) => (
                      <option key={type} value={type}>
                        {type === "education" ? "Education" : "Migration"}
                      </option>
                    ))}
                  </select>
                  {errors.application_type && (
                    <small className="text-danger mt-1 d-block">
                      {errors.application_type}
                    </small>
                  )}
                </div>

                {/* Fee */}
                <div className="col-md-6">
                  <label className="form-label fw-medium">
                    Fee per Application <span className="text-danger">*</span>
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter amount"
                    value={formData.fee_per_application}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        fee_per_application: e.target.value,
                      }))
                    }
                  />
                  {errors.fee_per_application && (
                    <small className="text-danger mt-1 d-block">
                      {errors.fee_per_application}
                    </small>
                  )}
                </div>

                {/* Currency */}
                <div className="col-md-6">
                  <label className="form-label fw-medium">
                    Currency <span className="text-danger">*</span>
                  </label>
                  <select
                    className="form-select"
                    value={formData.currency}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        currency: e.target.value,
                      }))
                    }
                  >
                    <option value="" disabled>
                      Select currency
                    </option>
                    {currencies.map((curr) => (
                      <option key={curr} value={curr}>
                        {curr}
                      </option>
                    ))}
                  </select>
                  {errors.currency && (
                    <small className="text-danger mt-1 d-block">
                      {errors.currency}
                    </small>
                  )}
                </div>

                {/* Active Toggle */}
                <div className="col-12 mt-3">
                  <div className="form-check form-switch d-flex align-items-center gap-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="is_active"
                      style={{
                        width: "44px",
                        height: "20px",
                      }}
                      checked={formData.is_active}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          is_active: e.target.checked,
                        }))
                      }
                    />
                    <label
                      className="form-check-label fw-medium"
                      htmlFor="is_active"
                      style={{ marginLeft: "20px" }}
                    >
                      {formData.is_active ? "Active" : "Inactive"}
                    </label>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="modal-footer border-top p-3 d-flex gap-2">
              <button
                type="button"
                className="btn btn-outline-secondary px-4"
                onClick={onClose}
                disabled={loading}
              >
                Cancel
              </button>
              <button
                type="button"
                className={`btn ${
                  isEditing ? "btn-primary" : "btn-success"
                } px-4`}
                onClick={handleSubmitForm}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" />
                    {isEditing ? "Updating..." : "Creating..."}
                  </>
                ) : isEditing ? (
                  "Update Rule"
                ) : (
                  "Create Rule"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ApplicationFeeRuleModal;
